import React from 'react';
import withIcon from '../utilities/withIcon';

const IconNumber8 = () => {
  return (
    <g>
      <path d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0zm-.05 3.897c-1.612 0-2.648.882-2.648 2.13a1.823 1.823 0 0 0 1.17 1.775l.149.05v.024c-.907.196-1.56.99-1.578 1.918 0 1.378 1.154 2.249 2.908 2.249 1.766 0 2.92-.871 2.92-2.249a2.003 2.003 0 0 0-1.42-1.877l-.158-.041v-.024a1.823 1.823 0 0 0 1.319-1.825c0-1.248-1.036-2.13-2.661-2.13zm0 4.52c.884 0 1.473.459 1.473 1.271 0 .813-.589 1.26-1.472 1.26-.872 0-1.46-.448-1.46-1.26s.588-1.27 1.46-1.27zm0-3.46a1.13 1.13 0 0 1 1.283 1.05l.001.126a1.145 1.145 0 0 1-1.283 1.19 1.136 1.136 0 0 1-1.27-1.065v-.125a1.121 1.121 0 0 1 1.27-1.177z" />
    </g>
  );
};

export default withIcon(IconNumber8);
